import {
  ReactElement, useEffect, useState,
} from 'react';
import { Helmet } from 'react-helmet';
import { t } from 'i18next';

import { AnalysisLayout } from '../AnalysisLayout';
import { generateNameFormatted } from '~/helpers/titleHelper';

import { MaintenanceHeader } from './MaintenanceHeader';
import { BigNumbers } from './BigNumbers';
import { Donuts } from './Charts/Donuts';
import { StatesBar } from './Charts/StatesBar';
import { MaintenanceAnalytics, getMaintenanceAnalytics } from './helpers/api';
import {
  MaintenanceFilters,
  MaintenanceViewBy,
  emptyMaintenanceFilters,
} from './types';
import { Container } from './styles';

export function MaintenanceLayout(): ReactElement {
  const [filters, setFilters] = useState<MaintenanceFilters>(emptyMaintenanceFilters);
  const [viewBy, setViewBy] = useState<MaintenanceViewBy>('machines');
  const [analytics, setAnalytics] = useState<MaintenanceAnalytics | undefined>();
  const [analyticsLoading, setAnalyticsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load(): Promise<void> {
      setAnalyticsLoading(true);
      const response = await getMaintenanceAnalytics(filters);
      if (cancelled) return;
      setAnalytics(response);
      setAnalyticsLoading(false);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [filters]);

  return (
    <Container>
      <Helmet>
        <title>{generateNameFormatted('Celsius 360', `${t('manutencao')} - ${t('gestaoAtivos')}`)}</title>
      </Helmet>
      <AnalysisLayout />
      <MaintenanceHeader
        filters={filters}
        onFiltersChange={setFilters}
        viewBy={viewBy}
        onChangeViewBy={setViewBy}
      />
      <BigNumbers filters={filters} />
      <Donuts analytics={analytics} loading={analyticsLoading} viewBy={viewBy} />
      <StatesBar analytics={analytics} loading={analyticsLoading} viewBy={viewBy} />
    </Container>
  );
}
